import { type ReactNode, useContext } from 'react';
import clsx from 'clsx';
import { Button, Paragraph, Heading } from '@hungryroot/ramen';
import { ResponsiveLayout as QuizResponsiveLayout } from '../../components/ResponsiveLayout/ResponsiveLayout';
import { QuizContext } from '../../quiz-context';
import styles from './Intro.module.css';

interface Props {
  testid: string;
  header: ReactNode;
  subcopy: string;
}

export const SUBCOPY = {
  DEFAULT: `You'll answer a few questions about you and how you eat. This helps us get to know you better so we can suggest food that you'll love before you shop. Ready?`,
};

export function Intro(props: Props) {
  const { testid, subcopy, header } = props;

  const context = useContext(QuizContext);
  const { onQuizInit } = context;

  return (
    <QuizResponsiveLayout
      className={clsx(styles.container, styles['container-default'])}
      header={header}
    >
      <div className={styles.body} key="intro">
        <section data-testid={testid} className={styles['intro-page']}>
          <div className={styles['text-section']}>
            <Heading testid={`${testid}-question-section-hero`} variant="H1Alt">
              Let's get started!
            </Heading>
            <Paragraph
              className={styles['prompt']}
              testid={`${testid}-question-section-subcopy`}
            >
              {subcopy}
            </Paragraph>
            <Button
              testid={`${testid}-button`}
              style="default"
              prominence="primary"
              size="large"
              buttonType="submit"
              onClick={() => {
                onQuizInit();
              }}
              textPrimary="Start"
              width="full-width-mobile"
            />
          </div>
          <img src="/public/img/cancel/intro_box.png" alt="hungryroot box" />
        </section>
      </div>
    </QuizResponsiveLayout>
  );
}
